import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { SubmittedSupportRequestsService } from "ClientApp/app/submitted-support-requests/services/submitted-support-requests.service";

export const SupportRequestStatusesResolver: ResolveFn<boolean> = async () => {
  await inject(SubmittedSupportRequestsService).getSupportRequestStatuses();

  return true;
}
